//@flow
export const GET_CROWD_WORKERS_DATA='GET_CROWD_WORKERS_DATA';
export const GET_CROWD_WORKERS_DATA_ERROR='GET_CROWD_WORKERS_DATA_ERROR';
export const OPEN_ASSIGN_NEW_CROWD_WORKER_FORM='OPEN_ASSIGN_NEW_CROWD_WORKER_FORM';
export const CANCEL_ASSIGN_NEW_CROWD_WORKER_FORM='CANCEL_ASSIGN_NEW_CROWD_WORKER_FORM';
export const SET_SEARCH_KEYWORD='SET_SEARCH_KEYWORD';
export const RECEIVED_SEARCH_CROWD_WORKER='RECEIVED_SEARCH_CROWD_WORKER';
export const RECEIVED_SEARCH_CROWD_WORKER_ERROR='RECEIVED_SEARCH_CROWD_WORKER_ERROR';
export const ASSIGN_NEW_CROWD_WORKER_SUCCESS='ASSIGN_NEW_CROWD_WORKER_SUCCESS';
export const ASSIGN_NEW_CROWD_WORKER_ERROR='ASSIGN_NEW_CROWD_WORKER_ERROR';
export const DELETED_A_CROWD_WORKER_SUCCESS='DELETED_A_CROWD_WORKER_SUCCESS';
export const DELETED_A_CROWD_WORKER_ERROR='DELETED_A_CROWD_WORKER_ERROR';


// WEBPACK FOOTER //
// ./src/redux/crowdWorkers/actionTypes.js